import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 24;

function EarthIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ICON_SIZE}
      height={ICON_SIZE}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M12 3a9 9 0 11-.001 18.001A9 9 0 0112 3zm0 1.636c-1.757 0-3.37.615-4.635 1.642l.017-.005 1.033 1.886-.516.973 1.17 1.161-2.67 1.12v.759l-1.458.726v.819l2.064.738.894.555v1.056l.516 1.591v.777a7.364 7.364 0 0010.89-7.366l-.623.114-1.267.344-.39-.657-1.066-1.025-1.629-.663-1.378.663-.816-1.39.355-.944 1.26-.926-.184-1.184-.427-.676A7.39 7.39 0 0012 4.636zm2.397 5.728l1.171.559.676.861.488 1.438-.93 2.867-.545.82-.531-.483-.571-1.11-1.31-1.485-.36-1.068.72-1.581 1.192-.818z"
      />
    </svg>
  );
}

EarthIcon.propTypes = {
  className: PropTypes.string,
};

EarthIcon.ICON_SIZE = ICON_SIZE;

export default EarthIcon;
